module.exports = __webpack_public_path__ + "static/fonts/element-icons.9b70ee41.woff";